import {ISculptToolWizardState} from "../../../types/ui/wizard/sculpt-tool";

export const initialSculptToolState: ISculptToolWizardState = {
  visible: false,
  height: 250,
  width: 200,
  x: 0,
  y: 0
};
